/**
 * Removes all HTML tags and returns plain text.
 * Works in all browsers (including React apps).
 * @param {string} html
 * @returns {string}
 */
export function getPlainTextFromHtml(html) {
  if (!html) return '';
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
}
